import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
import { ChMSTheme, isGivingOldTheme } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  root: {
    color: isGivingOldTheme(theme) ? '#0B6DFF' : ChMSTheme.colors['product-color']
  }
}));

const ChurchManagementSoftwareIcon = ({
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.822 11.964c.09 0 .178.004.266.01a6.073 6.073 0 012.992-4.988A4.957 4.957 0 007.964 4.8a4.963 4.963 0 00-2.556 9.22 3.86 3.86 0 013.414-2.056z",
    fill: "#FFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.514 14.48a4.963 4.963 0 01-4.106-.46 3.86 3.86 0 106.858 3.55 6.101 6.101 0 01-2.752-3.09z",
    fill: "#FFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.514 14.48a6.04 6.04 0 01-.426-2.508 3.863 3.863 0 00-3.68 2.046 4.93 4.93 0 002.556.708 4.848 4.848 0 001.55-.246z",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.156 6.15a6.058 6.058 0 00-3.078.836 4.94 4.94 0 01.85 2.778 4.94 4.94 0 01-1.33 3.38 3.845 3.845 0 011.082 2.68c0 .628-.15 1.22-.416 1.746.86.466 1.844.73 2.892.73a6.076 6.076 0 100-12.15z",
    fill: "#FFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.086 11.974a3.842 3.842 0 012.512 1.17 4.948 4.948 0 001.33-3.38c0-1.03-.314-1.984-.85-2.778a6.078 6.078 0 00-2.992 4.988z",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.598 13.144a4.971 4.971 0 01-2.084 1.336 6.106 6.106 0 002.75 3.09 3.848 3.848 0 00.416-1.746 3.84 3.84 0 00-1.082-2.68z",
    fill: "#FFF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.086 11.974a6.08 6.08 0 00.426 2.508 4.959 4.959 0 002.084-1.336 3.821 3.821 0 00-2.51-1.172z",
    fill: "#FFF"
  }));
};

export default ChurchManagementSoftwareIcon;